


export default {
    data() {
        return {
            observer: null,
            isTabCityStuck: false,
        }
    },

    async asyncData({ params, $auth, $axios, $config: { baseApiURL }, error }) {

        const promises = [
            $axios.$get(`${baseApiURL}/cities/${params.city}`)
                .catch((e) => {
                    if (e.response && e.response.status === 404) {
                        throw new Error('City not found');

                    } else {
                        throw e;
                    }
                }),
            $axios.$get(`${baseApiURL}/cities/${params.city}/reviews`)
                .catch((e) => {
                    if (e.response && e.response.status === 404) {
                        throw new Error('City reviews not found');
                    } else {
                        throw e;
                    }
                })
        ];

        if ($auth.loggedIn) {
            promises.push(
                $axios.$get(`${baseApiURL}/favorites/city/${params.city}`, { withCredentials: true })
                    .catch((e) => {
                        if (e.response && e.response.status === 404) {
                            return { 'status': false }; // Return a default value for 404 case
                        } else {
                            throw e;
                        }
                    })
            );
        } else {
            promises.push(Promise.resolve({ 'status': false }));
        }

        let propsResults, reviewsResults, favoritesResults;

        try {
            [propsResults, reviewsResults, favoritesResults] = await Promise.all(promises);
        } catch (e) {
            if (e.message === 'City not found') {
                error({ statusCode: 404, message: 'City not found' });
            } else if (e.message === 'City reviews not found') {
                error({ statusCode: 404, message: 'City reviews not found' });
                return;
            } else {
                // Handle other errors
                console.log(e);
                return;
            }
            return;
        }


        return {
            city: propsResults.city,
            labels: propsResults.labels,
            reviews: reviewsResults.reviews,
            metrics: propsResults.metrics,
            breadcrumbs: propsResults.breadcrumbs,
            nearCities: propsResults.nearCities,
            services: propsResults.services,
            elections: propsResults.elections,
            charts: propsResults.charts,
            token: propsResults.token,
            isFavorited: favoritesResults.status
        }
    },

    created() {
        if (process.client) {
            this.observer = new IntersectionObserver(
                this.onElementObserved,
                {
                    rootMargin: '-1px 0px 0px 0px',
                    root: this.$el,
                    threshold: 1,
                }
            );
        }
        this.$nuxt.$on("successfully-logged", data => {
            if (data && data.next === 'favorite') {
                this.favoriteCity();
            }
        });

    },
    beforeDestroy() {
        this.$nuxt.$off("successfully-logged");
    },
    methods: {
        onElementObserved(observables, observer) {
            observables.forEach(observable => {
                this.isTabCityStuck = (observable.intersectionRatio < 1);
            });
        },
        favoriteCity() {
            if (this.$auth.loggedIn) {

                this.$axios.$post(`/api/favorites/city/${this.city.id}/`)
                    .then((response) => {
                        this.isFavorited = response.status;
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 422) {

                        } else {
                            alert('Une erreur est survenue, veuillez réessayer ultérieurement.');
                        }
                    })
            } else {
                this.$nuxt.$emit("open-login-modal", { mode: 'login', next: 'favorite' });
            }
        }
    },

}

